import { createSelector } from 'reselect'
import { isLoyaltyLoungePassItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'

/**
 * Retrieves all loyalty lounge pass items in the checkout
 */
const getLoyaltyLoungePassItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => {
    return items.filter(isLoyaltyLoungePassItem)
  },
  reselectShallowEqual,
)

export default getLoyaltyLoungePassItems
